import React from 'react';

function Footer(){
    return (<footer>
        Ⓒ Alan Lee, {new Date().getFullYear()}
    </footer>)
};

export default Footer;